export enum WIDGET_PERSONAL_FEED_PREVIEW {
    /**
     * @value Access feed
     */
    ACCESS_FEED = 'WIDGET_PERSONAL_FEED_PREVIEW.ACCESS_FEED',
    /**
     * @value Contextual banner
     * @description Switch button name that allow the user to display or not the contextual banner
     */
    CONTEXTUAL_BANNER = 'WIDGET_PERSONAL_FEED_PREVIEW.CONTEXTUAL_BANNER',
    /**
     * @value See more in your feed
     */
    SEE_MORE_IN_YOUR_FEED = 'WIDGET_PERSONAL_FEED_PREVIEW.SEE_MORE_IN_YOUR_FEED',
    /**
     * @value Welcome message
     * @description Toggleable property option that allows the user to display or not the welcome message
     */
    WELCOME_MESSAGE = 'WIDGET_PERSONAL_FEED_PREVIEW.WELCOME_MESSAGE',
    /**
     * @value Display user name in the message.
     * @description Description of what the "Welcome message" switch does
     */
    WELCOME_MESSAGE_DESCRIPTION = 'WIDGET_PERSONAL_FEED_PREVIEW.WELCOME_MESSAGE_DESCRIPTION',
}
